<template>
  <div class="video-wrapper">
    <div id="local_video" class="zb-video" style="object-fit: cover;"></div>
	<playSvga ref="svga" v-if="show_svga"/>
  </div>
</template>

<script>
import { getChatRoomDetails } from "@/api/zhibo";
import playSvga from "../playSvga/playSvga.vue";
export default {
  components: {
    playSvga
  },
  data() {
    return {
	  livePusher:null,
	  audioEffectManager:null,
	  data:'',
	  show_svga:true,
	  isDeviceReady: false, // 标记媒体设备是否就绪
	  isPushing: false, // 标记是否正在推流
    };
  },
  mounted() {
	this.getLivePusher()
  },
  methods: {
	async getLivePusher(data){
		const quality = data?data:'720p'
		this.livePusher = new TXLivePusher();
		this.audioEffectManager  = this.livePusher.getAudioEffectManager()
		this.livePusher.setRenderView('local_video');
		this.livePusher.videoView.muted = true;
		// 设置视频质量
		this.livePusher.setVideoQuality(quality);
		// 设置音频质量
		this.livePusher.setAudioQuality('standard');
		// 自定义设置帧率
		this.livePusher.setProperty('setVideoFPS', 25);
		
		// 添加事件监听
		this.livePusher.setObserver({
			onPushStatusUpdate: (code, message) => {
				console.log('推流状态更新:', code, message);
				if (code === 1001) { // 正在连接
					this.isPushing = false;
				} else if (code === 1002) { // 连接成功
					this.isPushing = true;
					console.log('推流真正成功了');
				} else if (code === -1307) { // 连接断开
					this.isPushing = false;
					console.error('推流连接断开');
				}
			},
			onPushError: (code, message) => {
				console.error('推流错误:', code, message);
				this.isPushing = false;
			}
		});

		try {
			// 打开摄像头和麦克风，确保获取流成功后再继续
			console.log('正在启动摄像头和麦克风...');
			await this.livePusher.startCamera();
			await this.livePusher.startMicrophone();
			this.isDeviceReady = true;
			console.log('摄像头和麦克风启动成功');
			
			// 设备启动成功后再获取详情并开始推流
			await this.getChatRoomDetails()
		} catch (error) {
			console.error('媒体设备启动失败:', error);
			this.isDeviceReady = false;
		}
	},
	//开始推流
	async startPush(){
		if (!this.isDeviceReady) {
			console.warn('设备未就绪，推流取消');
			return;
		}
		const pushUrl = this.data.chatRoomDetails.pushUrl
		const newUrl = pushUrl.replace(/^rtmp:\/\//, 'webrtc://');
		
		try {
			console.log('正在尝试推流:', newUrl);
			await this.livePusher.startPush(newUrl);
			console.log('startPush 调用成功，等待状态更新...');
		} catch (error) {
			console.error('推流发起失败:', error);
			this.isPushing = false;
		}
	},
	//设置画质
	async setVideoQuality(data){
		if (this.livePusher) {
			this.livePusher.stopPush();
			this.livePusher.stopCamera();
			this.livePusher.stopMicrophone();
			this.livePusher.destroy()
			this.livePusher = null
		}
		this.isDeviceReady = false;
		this.isPushing = false;
		const quality = data===0?'720p':'360p'
		await this.getLivePusher(quality)
	},
	//直播间详情
	async getChatRoomDetails(){
		if(!this.$route.query.liveId){
		  return
		}
		const res = await getChatRoomDetails({liveId:this.$route.query.liveId})
		this.data = res.data
		console.log('获取推流链接')
		this.startPush()
	},
	//设置音量
	setVolume(data){
		console.log(data)
		this.audioEffectManager.setVolume(data)
	},
	//播放礼物
	addGiftToQueue(data){
		console.log(data,123)
		this.$refs.svga.addGiftToQueue(data)
	},
	//显示或者关闭特效
	showSvga(data){
		this.show_svga = data
	}
	
  },
  beforeDestroy() {
	if (this.livePusher) {
		this.livePusher.stopCamera();
		this.livePusher.stopMicrophone();
		this.livePusher.stopPush();
		this.livePusher.destroy()
		this.livePusher = null
	}
	console.log('停止采集')
  }
};
</script>
<style scoped lang="scss">
	@import "./tengxunyunzb.css";
</style>


// WEBPACK FOOTER //
// tengxunyunzb.vue?0653992d